module.exports = __webpack_public_path__ + "img/binmas.06c4137b.png";